export const RFInitialValues = {
  searchType: '0',
  searchValue: '',
  dateFilter: '1',
  categ: {
    adoptedSolutions: 0,
    initialInterview: 0,
    approved: 2,
    suspended: 2,
    rejected: 2,
    sentToCommittee: 0,
    expired: 2,
    granted: 2,
  },
  branchesDisabled: true,
  branchId: 1,
  productsDisabled: true,
  productId: 2,
}

export const formName = 'frm_application'
export const objectName = 'dbgrd_app'
